"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VCustomDateTimePicker = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var style_1 = require("../style");
var FormFieldContainer_1 = require("../FormFieldContainer");
var DateRangeUtils_1 = require("./utils/DateRangeUtils");
var DateRangeComponents_1 = require("./components/DateRangeComponents");
var Validators_1 = require("../../Validators");
var mobx_react_1 = require("mobx-react");
var moment_1 = __importDefault(require("moment"));
var VCustomDateTimePicker = function (props) {
    var className = props.className, disabled = props.disabled, inline = props.inline, fieldState = props.fieldState, id = props.id, labelInfo = props.labelInfo, layer = props.layer, fill = props.fill, margin = props.margin, noLabel = props.noLabel, required = props.required, displayRequired = props.displayRequired, label = props.label, value = props.value, tooltip = props.tooltip, tipLabel = props.tipLabel, dateType = props.dateType, onChange = props.onChange, format = props.format, maxTime = props.maxTime, minTime = props.minTime, validators = props.validators, selectedShortcutIndex = props.selectedShortcutIndex, shortcuts = props.shortcuts, onShortcutChange = props.onShortcutChange, startTimeProps = props.startTimeProps, endTimeProps = props.endTimeProps, useAmPm = props.useAmPm, precision = props.precision, dayPickerProps = props.dayPickerProps, popoverProps = props.popoverProps, allowSingleDayRange = props.allowSingleDayRange, subLabels = props.subLabels, upperCaseFormat = props.upperCaseFormat;
    var startValueTime = startTimeProps === null || startTimeProps === void 0 ? void 0 : startTimeProps.initValue;
    var endValueTime = endTimeProps === null || endTimeProps === void 0 ? void 0 : endTimeProps.initValue;
    var _a = (0, react_1.useState)({
        start: {
            date: null,
            time: DateRangeUtils_1.DateRangeUtils.includeTimeToDate((0, moment_1.default)().toDate(), 24, 0)
        },
        end: {
            date: null,
            time: DateRangeUtils_1.DateRangeUtils.includeTimeToDate((0, moment_1.default)().toDate(), 23, 59)
        }
    }), state = _a[0], setState = _a[1];
    var _b = DateRangeUtils_1.DateRangeUtils.transformState(state), startDate = _b.startDate, startTime = _b.startTime, endDate = _b.endDate, endTime = _b.endTime;
    var _c = (0, react_1.useState)(false), updateOrder = _c[0], setUpdateOrder = _c[1];
    (0, react_1.useEffect)(function () {
        initialState();
    }, []);
    (0, react_1.useEffect)(function () {
        setState(DateRangeUtils_1.DateRangeUtils.initialDate(fieldState, value, startValueTime, endValueTime));
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, start, end, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(fieldState === null || fieldState === void 0 ? void 0 : fieldState.value)) return [3, 3];
                        _a = fieldState.value, start = _a[0], end = _a[1];
                        _b = (start || end);
                        if (!_b) return [3, 2];
                        return [4, (fieldState === null || fieldState === void 0 ? void 0 : fieldState.validate())];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        _b;
                        _c.label = 3;
                    case 3: return [2];
                }
            });
        }); })();
    }, [fieldState === null || fieldState === void 0 ? void 0 : fieldState.value, value]);
    var initialState = function () {
        var hasValidators = !!(validators === null || validators === void 0 ? void 0 : validators.length);
        var newValidators = hasValidators ? validators !== null && validators !== void 0 ? validators : [] : [];
        if (required) {
            newValidators.push(Validators_1.Validators.requiredDateRange);
        }
        if (fieldState && !!newValidators.length) {
            fieldState.validators.apply(fieldState, newValidators);
        }
    };
    var onChangeDate = function (selectedDates) {
        var startDateSelected = selectedDates[0], endDateSelected = selectedDates[1];
        var newState = {
            start: {
                date: startDateSelected,
                time: startTime
            },
            end: {
                date: endDateSelected,
                time: endTime
            }
        };
        setState(newState);
    };
    var onChangeTime = function (type) { return function (value) {
        var _a;
        var key = type === 'START' ? 'start' : 'end';
        var newState = __assign(__assign({}, state), (_a = {}, _a["".concat(key)] = {
            date: type === 'START' ? startDate : endDate,
            time: value
        }, _a));
        setState(newState);
    }; };
    var onChangeDateTime = function (dateRange) {
        var startDateSelected = dateRange[0], endDateSelected = dateRange[1];
        setState({
            start: {
                date: startDateSelected,
                time: startDateSelected
                    ? startDateSelected
                    : DateRangeUtils_1.DateRangeUtils.includeTimeToDate((0, moment_1.default)().toDate(), 24, 0)
            },
            end: {
                date: endDateSelected,
                time: endDateSelected
                    ? endDateSelected
                    : DateRangeUtils_1.DateRangeUtils.includeTimeToDate((0, moment_1.default)().toDate(), 23, 59)
            }
        });
    };
    var globalOnChange = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newDates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newDates = DateRangeUtils_1.DateRangeUtils.buildRangeDate(state, dateType);
                    return [4, onChangeState(newDates)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var onChangeState = function (dateRange) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    (_a = fieldState === null || fieldState === void 0 ? void 0 : fieldState.onChange) === null || _a === void 0 ? void 0 : _a.call(fieldState, dateRange);
                    return [4, (fieldState === null || fieldState === void 0 ? void 0 : fieldState.validate())];
                case 1:
                    _b.sent();
                    onChange === null || onChange === void 0 ? void 0 : onChange(dateRange);
                    return [2];
            }
        });
    }); };
    var onBlurInputs = function (input) { return function (event) {
        var _a;
        var date = new Date((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
        var newValue = (fieldState === null || fieldState === void 0 ? void 0 : fieldState.value) || value || [null, null];
        if ((0, moment_1.default)(date).isValid()) {
            if (input === core_1.Boundary.START) {
                newValue[0] = date;
            }
            else {
                newValue[1] = date;
            }
            if (newValue[0] &&
                newValue[1] &&
                (0, moment_1.default)(newValue[0]).diff(newValue[1]) > 1) {
                setUpdateOrder(true);
                return;
            }
            fieldState === null || fieldState === void 0 ? void 0 : fieldState.onChange(newValue);
            onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
            setState(DateRangeUtils_1.DateRangeUtils.initialDate(fieldState, newValue, startValueTime, endValueTime));
            return;
        }
        setUpdateOrder(true);
    }; };
    return (react_1.default.createElement(mobx_react_1.Observer, { render: function () { return (react_1.default.createElement(style_1.StyledDatePicker, { className: className, disabled: disabled, inline: inline, intent: (fieldState === null || fieldState === void 0 ? void 0 : fieldState.hasError) ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, fill: fill, margin: margin, noLabel: noLabel },
            react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, value: value, tooltip: tooltip },
                tipLabel && react_1.default.createElement("span", { className: 'tipLabel' }, tipLabel),
                react_1.default.createElement(DateRangeComponents_1.DateRangeComponents, __assign({ state: state, onChangeDate: onChangeDate, onChangeTime: onChangeTime, onChangeDateTime: onChangeDateTime, dateType: dateType, format: format, minTime: minTime, maxTime: maxTime, shortcuts: shortcuts, selectedShortcutIndex: selectedShortcutIndex, onShortcutChange: onShortcutChange, disabled: disabled, startTimeProps: startTimeProps, endTimeProps: endTimeProps, useAmPm: useAmPm, precision: precision, dayPickerProps: dayPickerProps, popoverProps: popoverProps, onClosing: globalOnChange, allowSingleDayRange: allowSingleDayRange, upperCaseFormat: upperCaseFormat, tipLabels: subLabels, onBlurInputs: onBlurInputs }, { updateOrder: updateOrder, setUpdateOrder: setUpdateOrder }))))); } }));
};
exports.VCustomDateTimePicker = VCustomDateTimePicker;
